module.exports = __webpack_public_path__ + "img/hopital_general_juif.4891c09c.webp";